import styles from '../index.module.css';

interface Props {
  label: string;
  value: string;
  placeholder?: string;
  type?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextInputRow: React.FC<Props> = ({ label, ...inputProps }) => {
  return (
    <div className={styles.Row}>
      <div className={styles.Label}>{label}</div>
      <input className={styles.FormInput} {...inputProps} />
    </div>
  );
};

export default TextInputRow;
